// extracted by mini-css-extract-plugin
module.exports = {"welcomeMessage":"styles_welcomeMessage__1TKJu","sampleGraph":"styles_sampleGraph__2t_wQ","connectText":"styles_connectText__1YX2X"};